<p-autoComplete *ngIf="!storeDetailComplete"
        [style]="style"
        [inputStyle]="inputStyle"
        [suggestions]="storeList"
        [(ngModel)]="selectedStore"
        (completeMethod)="getFilteredStores($event)"
        [dropdown]="true"
        [disabled]="disabled"
        (onSelect)="changeStore($event)"
        field="label">
</p-autoComplete>
<p-autoComplete *ngIf="storeDetailComplete"
        [style]="style"
        [inputStyle]="inputStyle"
        [suggestions]="storeList"
        [(ngModel)]="selectedStore"
        (completeMethod)="getFilteredStoreDetails($event)"
        [dropdown]="true"
        [disabled]="disabled"
        (onSelect)="changeStore($event)"
        field="label">
</p-autoComplete>


// WEBPACK FOOTER //
// ./src/app/views/store/store-autocomplete/store-autocomplete.component.html